import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199


interface CustomTextWrapperProps {
    dangerouslySetInnerHTML?: any;
}

const CustomTextWrapper: React.SFC<CustomTextWrapperProps> = ({ dangerouslySetInnerHTML, ...props }) =>
    dangerouslySetInnerHTML ? (
        <span dangerouslySetInnerHTML={dangerouslySetInnerHTML} {...props} />
    )
    : (
        <React.Fragment {...props} />
    );

export { CustomTextWrapper };
